import { useRouter } from 'next/router';
import React from 'react';
import { useMobileApp } from '../../../../hooks/useMobileApp';
import { usePermission } from '../../../../hooks/usePermission';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
import { getQueryParam } from '../../../../utils/functions';
import DrawerEvent from '../../../account/DrawerMenu/DrawerEvent';
import MobilePreviewWrapper from '../../pageBuilder/MobilePreviewWrapper';
import MBWHeader from '../MBW/MBWHeader';
import Appointment from './appointment/Appointment';
import AttendeeMessagingButton from './AttendeeMessagingButton';
import { ControlSidebar } from './ControlSidebar';
import Header from './header';
import Main from './MainContent';
import MessagingCenter from './messaging/MessagingCenter';
import { OpenBooth } from './oneonone/OpenBooth';
import { PresentationLivestreamModal } from './UIComponents/PresentationUiComponent/PresentationLivestreamModal';

const VystemLight = () => {
  const user = useSelector((state) => state.common.user);
  const pagebuilder = useSelector((state) => state.common.pagebuilder);
  const pagedata = useSelector((state) => state.common.pagedata);
  const event = useSelector((state) => state.common.event);
  const templateEditMode = useSelector((state) => state.common.templateEditMode);

  const { isEventHost } = usePermission();
  const router = useRouter();
  const { isAppView } = useMobileApp();

  const isMenuBarActive =
    user && user.role !== 'PARTICIPANT_ANONYM' ? pagebuilder.currentpagedata?.template?.menuBar?.active : pagedata?.template?.menuBar?.active;

  const showMBWHeader =
    event?.organization?.supportedPagebuilderThemes &&
    event?.organization?.supportedPagebuilderThemes.includes('mbw') &&
    event.organization.defaultHeader === 'mbw';

  return (
    <>
      {!templateEditMode && isEventHost() && <DrawerEvent />}
      <MobilePreviewWrapper>
        {isMenuBarActive && (
          <>
            {!event?.organization?.supportedPagebuilderThemes ||
              ((event?.organization?.supportedPagebuilderThemes.length < 2 || event.organization.defaultHeader === 'default') && (
                <Header
                  menuItemsFade={
                    user && user.role !== 'PARTICIPANT_ANONYM'
                      ? pagebuilder.currentpagedata?.template?.menuBar?.menuFade
                      : pagedata?.template?.menuBar?.menuFade
                  }
                />
              ))}
            {showMBWHeader && <MBWHeader />}
          </>
        )}
        <OpenBooth />
        <PresentationLivestreamModal />

        <ControlSidebar />
        {router?.query?.pagename === 'appointment' ? (
          <Appointment />
        ) : isAppView() && getQueryParam('messaging') === 'true' ? (
          <>
            {/* This h-screen div is a fix for an issue occuring only on some Android devices, where the full height of the screen is not used otherwise. */}
            <div className="h-screen">
              <AttendeeMessagingButton visible={false} size="small" />
              <MessagingCenter />
            </div>
          </>
        ) : (
          <Main />
        )}
      </MobilePreviewWrapper>
    </>
  );
};

export default VystemLight;
